import { createSelector } from '@reduxjs/toolkit';

import { LoginState } from './types';

import type { RootState } from 'Store';

const selectAuthState = (state: RootState) => state.auth;

export const selectLoginState = createSelector(
  [selectAuthState],
  authState => authState.loginState
);

export const selectLoginError = createSelector(
  [selectAuthState],
  authState => authState.loginError
);

export const selectRegistrationError = createSelector(
  [selectAuthState],
  authState => authState.registrationError
);

export const selectResetPasswordError = createSelector(
  [selectAuthState],
  authState => authState.resetPasswordError
);

export const selectChangePasswordError = createSelector(
  [selectAuthState],
  authState => authState.changePasswordError
);

export const selectForgotPasswordError = createSelector(
  [selectAuthState],
  authState => authState.forgotPasswordError
);

export const selectIsChangePasswordSuccess = createSelector(
  [selectAuthState],
  authState => authState.isChangePasswordSuccess
);

export const selectIsRegistrationSuccess = createSelector(
  [selectAuthState],
  authState => authState.isRegistrationSuccess
);

export const selectIsForgotPasswordSuccess = createSelector(
  [selectAuthState],
  authState => authState.isForgotPasswordSuccess
);

export const selectIsLogged = createSelector(
  [selectLoginState],
  loginState => loginState === LoginState.LOGGED
);

export const selectIsLoginPending = createSelector(
  [selectLoginState],
  loginState => loginState === LoginState.PENDING
);

export const selectIsNotLogged = createSelector(
  [selectLoginState],
  loginState => loginState === LoginState.NOT_LOGGED
);

export const selectIsLoginRejected = createSelector(
  [selectLoginState],
  loginState => loginState === LoginState.LOGIN_REJECTED
);

export const selectHasLoginError = createSelector([selectLoginError], loginError => !!loginError);

export const selectHasRegistrationError = createSelector(
  [selectRegistrationError],
  registrationError => !!registrationError
);

export const selectHasResetPasswordError = createSelector(
  [selectResetPasswordError],
  resetPasswordError => !!resetPasswordError
);

export const selectHasChangePasswordError = createSelector(
  [selectChangePasswordError],
  changePasswordError => !!changePasswordError
);

export const selectCanShowSuccessMessage = createSelector(
  [selectIsChangePasswordSuccess, selectIsRegistrationSuccess],
  (isChangePasswordSuccess, isRegistrationSuccess) =>
    isChangePasswordSuccess === true || isRegistrationSuccess === true
);
